import React from 'react';
import PropTypes from 'prop-types';

import Label from 'styled/Label';
import Input from 'styled/Input';
import Select from 'components/Select';
import DashedButton from 'components/DashedButton';

import { COLORS } from 'styleguide';

import Header from './Header';

class Mascot extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <Header>
          <Label htmlFor="mascotPhrase">Маскот</Label>

          {!this.props.active && (
            <DashedButton
              onClick={this.props.onMascotActivate}
              disabled={this.props.disabled}
            >
              Включить
            </DashedButton>
          )}

          {this.props.active && (
            <DashedButton
              onClick={this.props.onMascotDeactivate}
              disabled={this.props.disabled}
            >
              Выключить
            </DashedButton>
          )}
        </Header>

        <div style={{ display: 'flex' }}>
          <Input
            id="mascotPhrase"
            type="text"
            onChange={this.props.onPhraseChange}
            value={this.props.mascotPhrase}
            disabled={!this.props.active}
            placeholder="Фраза маскота..."
            maxLength={50}
          />

          <div style={{ width: '80px' }}>
            <Select
              onChange={this.props.onTypeChange}
              value={this.props.mascotType}
              disabled={!this.props.active}
              style={{ fontSize: '14px', borderLeft: `1px solid ${COLORS.line}` }}
            >
              <option value="positive">👍</option> {/* eslint-disable-line jsx-a11y/accessible-emoji */}
              <option value="negative">👎</option> {/* eslint-disable-line jsx-a11y/accessible-emoji */}
            </Select>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Mascot.propTypes = {
  active: PropTypes.bool,
  onMascotActivate: PropTypes.func,
  onMascotDeactivate: PropTypes.func,
  onPhraseChange: PropTypes.func,
  mascotPhrase: PropTypes.string,
  mascotType: PropTypes.oneOf(['positive', 'negative']),
  onTypeChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Mascot.defaultProps = {
  active: false,
  mascotPhrase: '',
  onMascotActivate: () => {},
  onMascotDeactivate: () => {},
  onPhraseChange: () => {},
  mascotType: 'positive',
  onTypeChange: () => {},
  disabled: false,
};

export default Mascot;
